module.exports = __webpack_public_path__ + "img/jxl.dab01e04.png";